<script setup lang="ts">
import { usePlanI18n } from '@/composables/usePlanI18n'
import PaidPlanBadge from '@/components/dashboard/ui/PaidPlanBadge.vue'
import StatementHistoricRow from '@/components/dashboard/statements/StatementHistoricRow.vue'
import type { HistoricStatementYear } from '@/types/statementYears'
import type { DonorFinancialYear } from '@/types/donorFinancialYear'

const { planT } = usePlanI18n()

defineProps<{
  years: HistoricStatementYear[]
  isPaid: boolean
  financialYearForPeriod: (period: string) => DonorFinancialYear | undefined
}>()

const emit = defineEmits<{
  upgrade: []
}>()
</script>

<template>
  <div class="sa-card sa-card--flush">
    <div class="sa-statements-historic__hd">
      <div>
        <h2 class="sa-section-title">{{ $t('Dashboard.Statements.Historic.heading') }}</h2>
        <p class="sa-statements-historic__sub">
          {{ planT('Dashboard.Statements.Historic.subtitle') }}
        </p>
      </div>
      <button
        v-if="!isPaid"
        type="button"
        class="sa-btn-purple sa-btn-purple--compact"
        @click="emit('upgrade')"
      >
        {{ $t('Dashboard.Statements.Historic.free.unlockYears') }}
        <PaidPlanBadge />
      </button>
    </div>

    <div v-if="!isPaid" class="sa-statements-historic__locked">
      <div class="sa-statements-historic__locked-icon" aria-hidden="true">
        <svg viewBox="0 0 20 20" fill="currentColor">
          <path
            fill-rule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
      <p class="sa-statements-historic__locked-text">
        {{ $t('Dashboard.Statements.Historic.free.lockedTeaser') }}
      </p>
    </div>

    <div v-if="isPaid" class="sa-statements-historic__list">
      <StatementHistoricRow
        v-for="year in years"
        :key="year.period"
        :year="year"
        :financial-year="financialYearForPeriod(year.period)"
        :is-paid="isPaid"
      />
    </div>
  </div>
</template>
